import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("h1", null, "Select component", -1 /* HOISTED */);
const _hoisted_2 = { class: "list-detail-drawer__list-section__controls" };
import { useFuzzySearch } from "src/shared/store/common/fuzzy-search";
import { ref } from "vue";
import AddComponentReferenceTree from "./AddComponentReferenceTree.vue";
import ExtoleDrawer from "src/shared/v-components/ui/ExtoleDrawer.vue";
import SearchBar from "src/shared/v-components/ui/search/SearchBar.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AddComponentReferenceDrawer',
    props: {
        globalCampaignRootBuiltComponent: {},
        builtComponents: {}
    },
    emits: ["componentSelected"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isOpen = ref(true);
        const search = ref("");
        const selectComponent = (component) => {
            emit("componentSelected", component);
            isOpen.value = false;
        };
        const searchedReportTypes = useFuzzySearch(search, props.builtComponents, [
            "name",
        ]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ExtoleDrawer, {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isOpen).value = $event)),
                showClose: false
            }, {
                default: _withCtx(() => [
                    _createVNode(AddComponentReferenceTree, {
                        componentId: _ctx.globalCampaignRootBuiltComponent.id,
                        "active-component-ids": new Set(_unref(searchedReportTypes).map((item) => item.id)),
                        callbackFunction: selectComponent
                    }, {
                        title: _withCtx(() => [
                            _hoisted_1,
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(SearchBar, {
                                    search: search.value,
                                    "onUpdate:search": _cache[0] || (_cache[0] = ($event) => ((search).value = $event))
                                }, null, 8 /* PROPS */, ["search"])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["componentId", "active-component-ids"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
